module.exports = __webpack_public_path__ + "static/media/crane3.89d947fb.png";